import { request } from "services/api/util";
import axios from "axios";

class PresignedUploadUrlService {
  async getS3SignUrl(subDirectory, file) {
    const param = {
      key: `${subDirectory}/${file.name}`,
    };
    const config = {
      method: "post",
      url: `admin/presignedUploadUrlForContact`,
      data: param,
      headers: {
        "content-type": "application/json",
      },
    };
    return request(config);
  }

  async pushProfilePhotoToS3(presignedUrl, file) {
    await axios
      .put(presignedUrl, file, {
        headers: {
          "content-type": file.type,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

export default new PresignedUploadUrlService();
